import { useCallback } from 'react';
import { UsersReportAPI } from 'api/users-report';
import { Filter } from 'components/molecules/filters/types';
import { toastService } from 'components/molecules/toast';
import { DateRange } from 'components/organisms/projects-report/common/range-picker/types';
import { FieldFilter } from 'components/organisms/tasks/filters';
import { useTranslation } from 'hooks/use-translation';
import { logger } from 'services';

export const useExport = (
  range: DateRange,
  { criteria, type }: Filter,
): { exportAsCSV: () => void } => {
  const failureText = useTranslation('failure');
  const failureMessage = useTranslation(
    'reports.users_performance.export.error',
  );

  const exportAsCSV = useCallback(() => {
    UsersReportAPI.exportAsCSV(
      range,
      criteria.filter(FieldFilter.isValid),
      type,
    )
      .then((downloadUrl) => {
        window.open(downloadUrl, '_blank');
      })
      .catch((error) => {
        logger.error('error in exporting projects report', { error });
        toastService({
          title: failureText,
          message: failureMessage,
        }).error();
      });
  }, [criteria, range, type, failureText, failureMessage]);

  return {
    exportAsCSV,
  };
};
